import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import theme from "../ThemeSettings/Theme";
import { ThemeProvider } from "@mui/material/styles";

import Footer from "../PageComponents/Footer";
import Toolbar from "@mui/material/Toolbar";
import { Helmet } from "react-helmet";

import { useLocation } from "react-router-dom";

import termsAndPrivacyCopy from "./terms_and_privacy.json";

function TermsPage() {
  const location = useLocation();
  const hash = location.hash.replace("#", "").replaceAll("%20", " ") || "";

  const privacyFirst = hash === "privacy";

  return (
    <Box
      sx={{
        width: "100vw",
        maxHeight: "100vh",
        background: theme.palette.background.default,
        overflow: "auto",
      }}
    >
      <Helmet>
        <title>Salus | Terms</title>
      </Helmet>
      <Box
        sx={{
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ThemeProvider theme={theme}>
          <Toolbar />
          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "column",
              maxWidth: "900px",
              justifyContent: "center",
              gap: 2,
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-end",
                position: "sticky",
                top: 0,
                pt: 2,
                background: theme.palette.background.default,
              }}
            >
              <Typography variant="h4" noWrap>
                {privacyFirst ? "Privacy Policy" : "Terms of Service"}
              </Typography>
              <Typography color="text.secondary" variant="body2">
                Last Updated:{" " + termsAndPrivacyCopy.last_updated}
              </Typography>
            </Box>
            {(privacyFirst ? termsAndPrivacyCopy.privacy : termsAndPrivacyCopy.terms).map((term, index) => (
              <Typography key={index} color="main" variant="body1">
                {term}
              </Typography>
            ))}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-end",
                position: "sticky",
                top: 0,
                pt: 2,
                background: theme.palette.background.default,
              }}
            >
              <Typography variant="h4" noWrap>
                {privacyFirst ? "Terms of Service" : "Privacy Policy"}
              </Typography>
              <Typography color="text.secondary" variant="body2">
                Last Updated:{" " + termsAndPrivacyCopy.last_updated}
              </Typography>
            </Box>
            {(privacyFirst ? termsAndPrivacyCopy.terms : termsAndPrivacyCopy.privacy).map((term, index) => (
              <Typography key={index} color="main" variant="body1" sx={{ pb: 2 }}>
                {term}
              </Typography>
            ))}
          </Box>
          <Toolbar variant="dense" />

          <Footer />
        </ThemeProvider>
      </Box>
    </Box>
  );
}

export default TermsPage;
